import { createContext, useContext } from "react";
import { usePlatformWebSocket, type WebSocketStatus } from "@kubdee/sdk/hooks/use-platform-websocket";

interface PlatformWebSocketContextValue {
  status: WebSocketStatus;
  reconnect: () => void;
}

const PlatformWebSocketContext = createContext<PlatformWebSocketContextValue>({
  status: "disconnected",
  reconnect: () => {},
});

export function PlatformWebSocketProvider({ children }: { children: React.ReactNode }) {
  const { status, reconnect } = usePlatformWebSocket();
  return (
    <PlatformWebSocketContext.Provider value={{ status, reconnect }}>
      {children}
    </PlatformWebSocketContext.Provider>
  );
}

export function usePlatformWsStatus() {
  return useContext(PlatformWebSocketContext);
}
